import { app } from '../../../app';
import { Controller } from './idp-authenticators.controller';

app.component('companyIdpAuthenticators', {
    controller: Controller,
    templateUrl: require('./idp-authenticators.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/idp-authenticators.component.js